import React from "react";
import { Logo } from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/market";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F5F8F6]">
      <div className="relative bg-gradient-to-br from-[#095F2E] to-[#0B7A3B] px-6 pt-14 pb-10 rounded-b-[32px] overflow-hidden">
        <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full bg-white/10" />
        <div className="absolute -left-6 bottom-2 w-24 h-24 rounded-full bg-white/5" />
        <div className="relative">
          <Logo size={44} light />
          <h1 className="text-white text-3xl font-extrabold tracking-tight mt-6">{title}</h1>
          <p className="text-white/80 mt-1">{subtitle}</p>
        </div>
      </div>
      <div className="flex-1 px-6 -mt-5">
        <div className="bg-white rounded-[24px] p-5 shadow-[0_8px_30px_rgba(11,122,59,0.10)]">{children}</div>
      </div>
    </div>
  );
}

export function GoogleButton() {
  return (
    <button
      type="button"
      onClick={googleLogin}
      data-testid="google-login-btn"
      className="w-full flex items-center justify-center gap-2 border border-[#DDF0E5] rounded-full py-3 font-bold text-[#122117] active:scale-95 transition-transform hover:bg-[#F5F8F6]"
    >
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
      Continue with Google
    </button>
  );
}

export const inputClass =
  "w-full bg-[#F5F8F6] rounded-[14px] px-4 py-3 text-[#122117] placeholder-[#6B8375] focus:outline-none focus:ring-2 focus:ring-[#0B7A3B] border-none";
